module.exports = __webpack_public_path__ + "img/vertical_spacing.bb704daa.svg";